import React from "react";
import { Skeleton } from "@mui/material";
import ArtworkCard, { ArtworkCardData } from "./ArtworkCard";

type ArtworkGridProps = {
  artworks: ArtworkCardData[];
  imageBaseUrl: string;
  isLoading: boolean;
};

const ArtworkGrid = ({ artworks, imageBaseUrl, isLoading }: ArtworkGridProps) => {
  if (isLoading) {
    return (
      <div className="art-grid" aria-busy="true">
        {[1, 2, 3, 4].map((index) => (
          <div className="art-card art-card--loading" key={index}>
            <Skeleton sx={{ bgcolor: "grey.900" }} variant="rectangular" width="100%" height="100%" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="art-grid">
      {artworks.map((artwork) => (
        <ArtworkCard artwork={artwork} imageBaseUrl={imageBaseUrl} key={artwork.id} />
      ))}
    </div>
  );
};

export default ArtworkGrid;

